module.exports = __webpack_public_path__ + "static/media/RN-2025-02.9b0cbdfa.jpg";